module.exports = __webpack_public_path__ + "img/logo_mohfw_1.5e5a838a.png";